import { render, staticRenderFns } from "./equipment_act.vue?vue&type=template&id=a41ef374&scoped=true&"
import script from "./equipment_act.vue?vue&type=script&lang=js&"
export * from "./equipment_act.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41ef374",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a41ef374')) {
      api.createRecord('a41ef374', component.options)
    } else {
      api.reload('a41ef374', component.options)
    }
    module.hot.accept("./equipment_act.vue?vue&type=template&id=a41ef374&scoped=true&", function () {
      api.rerender('a41ef374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/equipments/equipment_act.vue"
export default component.exports